var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44.5,
    fill: "#F9FCF9",
    fillOpacity: 0.8,
    stroke: "#DBDFDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4849 40.055V36.0276C38.4588 34.0725 39.7361 30.1468 45.0539 30.0842C47.1132 29.9799 51.357 31.0226 51.8575 36.0276V40.055H38.4849ZM33.48 40.055V34.6199C34.7938 26.7997 41.7433 24.9489 45.0539 25.0011C55.0638 25.1587 56.5757 32.1175 56.7061 34.6199V40.055H59.1303C59.4562 40.1071 60.0844 40.3678 59.9906 40.9934V62.0298C59.8863 63.0204 59.0443 65.0015 56.5106 65.0015H33.1672C32.32 64.806 30.524 63.9849 30.1173 62.2644L30 40.9934C30.0391 40.6546 30.2972 39.9925 31.0166 40.055H33.48ZM46.8845 53.3525C47.6933 52.7786 48.2211 51.8347 48.2211 50.7676C48.2211 49.0184 46.8031 47.6004 45.0539 47.6004C43.3047 47.6004 41.8867 49.0184 41.8867 50.7676C41.8867 51.8057 42.3862 52.7271 43.1579 53.3048L42.6297 57.4928C42.5385 57.8708 42.5202 58.6737 43.1771 58.8614H46.8526C47.1133 58.7571 47.6268 58.4 47.5955 57.8056L46.8845 53.3525Z",
    fill: "#70AFFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBag);
export default __webpack_public_path__ + "static/media/lock-bag.fda00751a6f49b13779063a48d129785.svg";
export { ForwardRef as ReactComponent };